export const SubTitle = () => {
  return <>직장 병행 IT 부트캠프</>;
};

export const Title = () => {
  return (
    <>
      IT로 완성하는
      <br />내 커리어
    </>
  );
};

export const Desc = () => {
  return (
    <>
      정보를 찾기 어렵다는 이유로, 시간이 부족하다는 이유로 원하는 삶을 포기하지
      마세요. 실무를 그대로 옮겨온 커리큘럼을 100% 온라인으로 경험하세요. 지금
      다니는 직장을 그만 두지 않아도 커리어 전환이 가능합니다.
    </>
  );
};
